import React from 'react';
import Cell from './Cell';

const cellRenderer = ({ cellData, columnData, rowData }) => {
  return <Cell cellData={cellData} columnData={columnData} rowData={rowData} />;
};

export default cellRenderer;
